<template>
    <div class="card card-body index p-0">
        <div class="top-button-group">
            <a href="/conversation-clubs" class="btn btn-light">Zobrazit rozvrh</a>
        </div>

      <!-- Hlavní filtrační lišta -->
      <div class="filters-bar d-flex align-items-center p-3 border-bottom">
        <!-- Vlevo: Vyhledávač -->
        <div class="search-box">
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <svg class="svg-inline--fa fa-search fa-w-16" aria-hidden="true" focusable="false" 
                     data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512" data-fa-i2svg="">
                  <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
                </svg>
              </div>
            </div>
            <input placeholder="Hledat" class="form-control" type="search" v-model="search_lector"/>
          </div>
        </div>

        <!-- Uprostřed: Filtry -->
        <div class="filters-center d-flex align-items-center mx-3">
          <!-- Radio buttony pro active status -->
          <div class="btn-group btn-group-sm mr-3" role="group">
            <label class="btn btn-outline-secondary" :class="{'active': active_filter === 'all'}">
              <input type="radio" value="all" v-model="active_filter" /> Všichni
            </label>
            <label class="btn btn-outline-secondary" :class="{'active': active_filter === 'active'}">
              <input type="radio" value="active" v-model="active_filter" /> Aktivní
            </label>
            <label class="btn btn-outline-secondary" :class="{'active': active_filter === 'inactive'}">
              <input type="radio" value="inactive" v-model="active_filter" /> Neaktivní
            </label>
          </div>

          <!-- Checkboxy pro typ lektora -->
          <div class="lector-type-filters d-flex">
            <div class="form-check form-check-inline mr-2">
              <input class="form-check-input" type="checkbox" id="kk_lector_check" v-model="kk_lector_filter">
              <label class="form-check-label" for="kk_lector_check">KK lektor</label>
            </div>
            <div class="form-check form-check-inline mr-2">
              <input class="form-check-input" type="checkbox" id="ll_lector_check" v-model="ll_lector_filter">
              <label class="form-check-label" for="ll_lector_check">LL lektor</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="checkbox" id="onla_lector_check" v-model="onla_lector_filter">
              <label class="form-check-label" for="onla_lector_check">ONLA lektor</label>
            </div>
          </div>
        </div>

        <!-- Vpravo: Tlačítko přidat -->
        <div class="ml-auto">
          <button class="btn btn-primary" @click.prevent="newLector">
            <span class="material-icons mia">add_circle</span> Přidat lektora
          </button>
        </div>
      </div>


      <OjPagination
          class="m-auto"
          :totalItems="total"
          :currentPage="page"
          :perPage="per"
          @pageChanged="pageChanged" />

        <table class="table">
            <thead>
            <tr>
                <th></th>
                <th>Jméno</th>
                <th></th>
                <th>Typ</th>
                <th class="text-center">KK lekce/měsíc</th>
                <th class="text-center">LL lekce/měsíc</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="l in lectors" :key="l.id">
                <td>
                    <img :src="l.profile_image_url ? l.profile_image_url : '/img/lecdor-default-avatar.png'" class="user-ico"/>
                </td>
                <td style="width: 40%">
                    {{l.first_name}} {{l.last_name}}

                </td>
                <td><span v-if="!l.active" class="badge badge-secondary ml-2">Neaktivní</span></td>


                <td>
                    <span v-if="l.kk_lector" class="badge badge-info mr-1">KK</span>
                    <span v-if="l.ll_lector" class="badge badge-success mr-1">LL</span>
                    <span v-if="l.rate_onla_45 && l.rate_onla_45 > 0" class="badge badge-purple">ONLA</span>
                </td>
                <td class="text-center">
                    <span v-if="l.kk_lector">{{l.kk_lessons_count || 0}}</span>
                    <span v-else class="text-muted">-</span>
                </td>
                <td class="text-center">
                    <span v-if="l.ll_lector">{{l.ll_lessons_count || 0}}</span>
                    <span v-else class="text-muted">-</span>
                </td>
                <td><a href="#" @click.prevent="editLector(l)"><span class="material-icons-outlined">mode_edit_outline</span></a></td>
            </tr>
            </tbody>
        </table>
      <OjPagination
          class="m-auto"
          :totalItems="total"
          :currentPage="page"
          :perPage="per"
          @pageChanged="pageChanged" />

        <modal-lector :user="lector" ref="modalLector" @userUpdated="onUserUpdated"></modal-lector>
    </div>

</template>

<script>
import axios from "axios";
import ModalLector from "./modal-lector.vue";
import OjPagination from "./OjPagination.vue";
import _ from "lodash";
export default {
  name: "cc-lectors",
  components: {OjPagination, ModalLector},
  data(){
    return {
      total:0,
      per:20,
      page:1,
        lectors: [],
        lector:{},
        search_lector:'',
      search_lector2:"",
      active_filter: 'all',
      kk_lector_filter: true,
      ll_lector_filter: true,
      onla_lector_filter: true,
      abortController: null
    }
  },

  mounted() {
    this.loadLectors()
  },

  watch:{
    search_lector(){
      this.search(this)
    },
    active_filter(){
      this.page = 1
      this.loadLectors()
    },
    kk_lector_filter(){
      this.page = 1
      this.loadLectors()
    },
    ll_lector_filter(){
      this.page = 1
      this.loadLectors()
    },
    onla_lector_filter(){
      this.page = 1
      this.loadLectors()
    }
  },


  methods:{
    pageChanged(p){
      this.page=p
      this.loadLectors()
    },

    search: _.debounce((vm) => {

      vm.loadLectors()

    }, 550),

      onUserUpdated(){
          this.loadLectors()
      },
    async loadLectors(){
      // Zrušit předchozí request, pokud existuje
      if (this.abortController) {
        this.abortController.abort()
      }
      
      // Vytvořit nový AbortController pro tento request
      this.abortController = new AbortController()
      
      try {
        const r2 = await axios.get('/lectors.json', {
          params: {
            search: this.search_lector, 
            per: this.per, 
            page: this.page,
            active_filter: this.active_filter,
            kk_lector: this.kk_lector_filter,
            ll_lector: this.ll_lector_filter,
            onla_lector: this.onla_lector_filter
          },
          signal: this.abortController.signal
        })
        
        this.lectors = r2.data.items
        this.total = r2.data.total
        for(let i in this.lectors){
            if (this.lectors[i].kk_levels==null) this.lectors[i].kk_levels=''
        }
      } catch (error) {
        // Ignorovat AbortError - to je očekávané chování
        if (error.name !== 'CanceledError' && error.name !== 'AbortError') {
          console.error('Error loading lectors:', error)
        }
      }
    },
    editLector(l){
        this.lector = l
        this.$refs.modalLector.showModal()
    },
    newLector(){
        this.lector = {}
        this.$refs.modalLector.showModal()
    }


  }
}
</script>

<style scoped>

.user-ico{
    width:30px;
    border-radius: 14px;
}

/* Filtrační lišta */
.filters-bar {
    background-color: #f8f9fa;
    gap: 1rem;
}

.search-box {
    min-width: 250px;
}

.search-box .input-group-text {
    background-color: white;
    border-right: 0;
}

.search-box input {
    border-left: 0;
}

.search-box .svg-inline--fa {
    width: 14px;
    height: 14px;
}

/* Filtry uprostřed */
.filters-center {
    flex-grow: 1;
}

/* Radio buttony */
.btn-group input[type="radio"] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
}

.btn-group .btn {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
}

.btn-group .btn.active {
    background-color: #007bff;
    color: white;
    border-color: #007bff;
}

.btn-group .btn:hover:not(.active) {
    background-color: #e9ecef;
}

/* Checkboxy pro typ lektora */
.lector-type-filters {
    padding-left: 1rem;
    border-left: 1px solid #dee2e6;
}

.form-check-label {
    font-size: 0.875rem;
    cursor: pointer;
    user-select: none;
}

.form-check-input {
    cursor: pointer;
}

/* Tabulka */
.table thead th {
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.table tbody tr {
    transition: background-color 0.15s ease-in-out;
}

.table tbody tr:hover {
    background-color: #f8f9fa;
}

.table td {
    vertical-align: middle;
}

.badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
}

.badge-purple {
    background-color: #6f42c1;
    color: white;
}

/* Responzivita pro menší obrazovky */
@media (max-width: 1200px) {
    .filters-bar {
        flex-wrap: wrap;
    }
    
    .search-box {
        min-width: 200px;
    }
    
    .filters-center {
        width: 100%;
        margin-top: 0.5rem;
        padding-top: 0.5rem;
        border-top: 1px solid #dee2e6;
    }
}
</style>